import styled from '@emotion/styled';

const CenteredBody = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export default CenteredBody;
